module.exports = __webpack_public_path__ + "static/media/ETH-FIL.b9f29ffc.png";